import { CSSProperties, MouseEventHandler } from 'react';
import { Center } from '~/commonComponents/Center';
import { SmartTooltip } from '~/commonComponents/SmartTooltip/SmartTooltip';
import './IconButton.scss';

interface IIconButtonProps {
  src?: string;
  buttonStyle?: CSSProperties;
  imgStyle?: CSSProperties;
  disabled?: boolean;
  hideTooltip?: boolean;
  alt?: string;
  Icon?: React.ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  tooltipContent?: React.ReactNode;
  dataCy?: string;
}

export const IconButton = ({
  src,
  Icon,
  buttonStyle,
  imgStyle,
  disabled = false,
  hideTooltip = false,
  alt = '',
  onClick = () => {},
  tooltipContent = '',
  dataCy,
}: IIconButtonProps) => (
  <SmartTooltip
    content={tooltipContent}
    position="bottom"
    alignment="center"
    trigger="hover"
    className="smart-tooltip"
    disabled={hideTooltip}
  >
    <button
      type="button"
      style={{
        border: 'none',
        backgroundColor: 'transparent',
        cursor: disabled ? 'default' : 'pointer',
        ...buttonStyle,
      }}
      onClick={onClick}
      disabled={disabled}
      data-cy={dataCy}
    >
      {Icon ? (
        <Center>{Icon}</Center>
      ) : (
        <img
          src={src}
          alt={alt}
          style={{
            width: 10,
            ...imgStyle,
          }}
        />
      )}
    </button>
  </SmartTooltip>
);
